import styled, { css } from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import {
  Inputbox as commonInputbox,
  Input as commonInput,
} from '../../assets/Common/Inputbox.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  padding: 0 0 20px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`;

export const Title = styled.h2`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  cursor: default;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  align-items: stretch;
`;

export const Footer = styled.div`
  display: inline-grid;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  grid-template-columns: auto auto;
  grid-gap: 15px;

  ${Media.sm`
    grid-template-columns: 1fr;
  `}
`;

export const Button = styled.button`
  ${commonButton}
  display: inline-flex;
  width: auto;
  min-width: 175px;
`;

export const Textbox = styled.div`
  display: block;
  width: 100%;
  margin-top: 15px;
  margin-bottom: 25px;
  text-align: center;

  ${(props) =>
    props.center &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    `}
`;

export const Text = styled.p`
  color: ${(props) => props.theme.color};
  font-size: 24px;
  font-weight: 400;
  line-height: 1.2;
  cursor: default;
`;

export const Box = styled.div`
  display: flex;
  width: 100%;

  ${Media.lg`
    flex-direction: column;
  `}
`;

export const Aside = styled.div`
  display: block;
  width: 100%;
  max-width: 276px;
  padding: 40px 20px 0 0;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }

  ${Media.lg`
    max-width: initial;
    padding: 20px 10px;
  `}
`;

export const Main = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: auto;
  padding: 40px 40px 20px 20px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }

  ${Media.xlg`
    flex-direction: column;
  `}

  ${Media.lg`
    padding: 20px 10px;
    overflow: initial;
  `}
`;

export const MainInner = styled.div`
  display: block;
  width: 100%;
  max-width: 560px;

  ${Media.xlg`
    max-width: initial;
  `}
`;

export const Side = styled.div`
  display: block;
  width: 100%;
  max-width: 40%;
  text-align: center;

  ${Media.xlg`
    max-width: initial;
  `}
`;

export const Subtitle = styled.h6`
  display: block;
  width: 100%;
  margin-bottom: 15px;
  color: ${(props) => props.theme.color};
  font-size: 18px;
  font-weight: 600;
  cursor: default;
`;

export const Group = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 30px;
`;

export const Inputbox = styled.div`
  ${commonInputbox}
  margin-bottom: 15px;
`;

export const Input = styled.input`
  ${commonInput}
`;
